import ArtistHeader from "../../shared/ArtistHeader/header";
import FanHeader from "../../shared/FanHeader/header";
import Header from "../../shared/header/header";
import Footer from "../../shared/footer/footer";

const TermsAndCondition = () => {
	return (
		<div>
			{localStorage.getItem("tokenFan") ? (
				<FanHeader />
			) : localStorage.getItem("tokenArtist") ? (
				<ArtistHeader />
			) : (
				<Header />
			)}
			{/* <Header /> */}
			<section id="content" className="pt40">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<div className="terms-conditions-content text-color">
								<div className="terms-conditions-heading">
									<h1 className="text-orange din-font text-uppercase text-center">
										Terms & Conditions
									</h1>
									<br></br>
									<p>
										These General Terms and Conditions ("Terms") govern your use of the DalbumX service, 
										website, and mobile application (collectively, the "Service"). By accessing, using, 
										or downloading the DalbumX app or website, you agree to be bound by these Terms. 
										If you do not agree, you may not use the Service.
									</p>
								</div>
								<div>
									<h2 className="fw-bold mt-4 mb-3 heading-bold">1. SERVICE OVERVIEW</h2>
									<p>
										DalbumX is a digital music distribution platform operated by DalbumX LLC, a Florida limited liability company.
										 The Service allows artists and musicians ("Admins") to publish digital albums ("Dalbums") containing audio tracks,
										  artwork, liner notes, and supplementary content, which fans can download through our DalbumXchange marketplace.
									</p>
									<p>DalbumX is currently available only to users in the United States.</p>
									<h2 className="fw-bold mt-4 mb-3 heading-bold">2. APPLICABLE AGREEMENTS</h2>
									<p>Your use of DalbumX is governed by the following documents, which are all incorporated herein by reference:</p>
									<ul>
										<li><strong>Artist Agreement:</strong> Governs artists/admins who publish Dalbums</li>
										<li><strong>End User License Agreement (EULA):</strong> Governs fans who use Dalbums</li>
										<li><strong>Content Policy & Community Guidelines:</strong> Defines permitted and prohibited content</li>
										<li><strong>Copyright and DMCA Policy:</strong> Describes copyright procedures and DMCA compliance</li>
										<li><strong>Privacy Policy:</strong> Explains how we collect, use, and protect your data
											In the event of any conflict between these Terms and the specific agreements listed above, the specific 
											agreement shall govern. However, these Terms provide general provisions applicable to all users.</li>
									</ul>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">3. USER ACCOUNTS AND ELIGIBILITY</h2>
									<h3 className="fw-bold mt-3 mb-2 heading-bold">3.1 Account Requirements</h3>
									<p>To use DalbumX, you must: (a) be at least 18 years old (or have parental consent if between 13-17), 
										(b) be a resident of the United States, (c) provide accurate information, (d) maintain the confidentiality of your login credentials, and 
										(e) comply with all applicable laws.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">3.2 Your Responsibilities</h3>
									<p>You are responsible for all activity under your account. You agree to notify us immediately of any unauthorized access or use.
										DalbumX is not liable for any harm caused by unauthorized account use.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">3.3 Account Suspension and Termination</h3>
									<p>DalbumX may suspend or terminate your account at any time if you violate these Terms, violate our Content Policy, engage in fraudulent activity, 
									or for other material breaches. We will provide notice via email unless prohibited by law
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">4. INTELLECTUAL PROPERTY RIGHTS</h2>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">4.1 User Content Ownership</h3>
									<p>You retain all ownership rights in any content you upload to DalbumX. By uploading content, you grant DalbumX a worldwide, non-exclusive license to host, distribute, 
										and display your content solely through the DalbumXchange and DalbumX service
									</p>
									<h3 className="fw-bold mt-3 mb-2 heading-bold">4.2 DalbumX Intellectual Property</h3>
									<p>
										All content, design, text, graphics, logos, and functionality of the DalbumX service are owned by or licensed to DalbumX and are protected by U.S. and international copyright and 
										trademark laws. You may not reproduce, modify, distribute, or use any DalbumX intellectual property without permission
									</p>
									<h3 className="fw-bold mt-3 mb-2 heading-bold">4.3 Your Representations Regarding Content</h3>
									<p>You represent and warrant that: (a) you own or have licensed all rights to any content you upload, (b) your content does not infringe any third-party intellectual property, privacy, 
										or publicity rights, and (c) you have obtained all necessary permissions from co-creators, performers, and rights holders
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">5. PROHIBITED CONDUCT</h2>

									<p>You agree that you will NOT:</p>
									
									<ul>
										<li>Upload, distribute, or display any content that is illegal, obscene, defamatory, or violates third-party rights</li>
										<li>Engage in harassment, bullying, doxxing, or threats toward other users</li>
										<li>Attempt to gain unauthorized access to DalbumX systems or other users' accounts</li>
										<li>Reverse engineer, decompile, or attempt to discover DalbumX source code or technology</li>
										<li>Circumvent any technological protection measures or security controls</li>
										<li>Use automated tools, bots, or scripts to access or use the Service without permission</li>
										<li>Artificially inflate metrics such as views, plays and engagement.</li>
										<li>Engage in any form of fraud, payment manipulation, or financial misconduct</li>
										<li>Violate any applicable laws, regulations, or these Terms</li>
									</ul>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">6. CONTENT MODERATION</h2>

									<p>
										DalbumX reviews all user-submitted content before publication to ensure compliance with our Content Policy. 
										While we strive to identify and remove prohibited content, we do not review every element of every submission. 
										You acknowledge that some prohibited content may remain on the Service and that DalbumX is not liable for content violations by other users.
									</p>

									<p>
										If you encounter prohibited content, please report it to legal@dalbumx.com (for general violations) or copyright@dalbumx.com (for copyright infringement).
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">7. DISCLAIMERS AND WARRANTIES</h2>

									<p>
										<strong>THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT ANY WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
											TITLE, OR NON-INFRINGEMENT.
										</strong>
									</p>
									<p>
										<strong>DALBUMX DOES NOT WARRANT THAT: (a) THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR SECURE, (b) DEFECTS WILL BE CORRECTED, (c) YOUR DALBUM WILL GENERATE ANY SPECIFIC SALES OR REVENUE, 
											(d) THE SERVICE WILL MEET YOUR EXPECTATIONS, OR (e) THE QUALITY OF PRODUCTS AND SERVICES WILL SATISFY YOUR NEEDS.
										</strong>
									</p>

									<p>
										YOU ACKNOWLEDGE THAT THE INTERNET AND DIGITAL SERVICES ARE SUBJECT TO TECHNICAL LIMITATIONS, OUTAGES, AND DELAYS BEYOND DALBUMX'S CONTROL.
									</p>
									
									<h2 className="fw-bold mt-4 mb-3 heading-bold">8. LIMITATION OF LIABILITY</h2>

									<p>
										<strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, DALBUMX'S TOTAL LIABILITY FOR ALL CLAIMS ARISING FROM OR RELATED TO THESE TERMS SHALL NOT EXCEED THE GREATER OF: (a) $100, OR (b) THE TOTAL AMOUNT 
											YOU PAID TO DALBUMX IN THE 12 MONTHS PRECEDING THE CLAIM.
										</strong>
									</p>

									<p>
										<strong>DALBUMX SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFITS, LOST REVENUE, LOST DATA, OR LOSS OF GOODWILL, EVEN IF ADVISED OF
											THE POSSIBILITY OF SUCH DAMAGES.
										</strong>
									</p>

									<p>
										SOME JURISDICTIONS DO NOT ALLOW LIMITATION OF LIABILITY, SO THESE LIMITATIONS MAY NOT APPLY TO YOU. IN SUCH JURISDICTIONS, LIABILITY WILL BE LIMITED TO THE GREATEST EXTENT PERMITTED BY LAW.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">9. INDEMNIFICATION</h2>

									<p>You agree to indemnify, defend, and hold harmless DalbumX LLC, its officers, directors, employees, and agents from any claims, damages, losses, or expenses (including reasonable attorneys' fees)
										arising from or related to: (a) your use of the Service, (b) your violation of these Terms or any applicable law, (c) your content or intellectual property claims, (d) your violation of third-party rights, 
										or (e) any other user actions on your account.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">10. DISPUTE RESOLUTION AND GOVERNING LAW</h2>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">10.1 Informal Resolution</h3>
									<p>
										Before filing any legal claim, you agree to contact legal@dalbumx.com and attempt to resolve the dispute informally.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">10.2 Binding Arbitration</h3>

									<p>
										Any dispute not resolved informally shall be resolved by binding arbitration administered by the American Arbitration Association (AAA) under its Commercial Arbitration Rules. The arbitration shall be conducted
										virtually unless both parties agree otherwise. Each party shall bear its own costs and attorneys' fees, with arbitrator fees split equally
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">10.3 Class Action Waiver</h3>

									<p>
										<strong>YOU AND DALBUMX AGREE THAT ALL DISPUTES MUST BE BROUGHT INDIVIDUALLY. YOU WAIVE ANY RIGHT TO BRING CLAIMS AS A PLAINTIFF OR CLASS MEMBER IN ANY CLASS ACTION, CONSOLIDATED ACTION, OR REPRESENTATIVE PROCEEDING.</strong>
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">10.4 Governing Law</h3>
									<p>
										These Terms shall be governed by and construed in accordance with the laws of the State of Florida, without regard to its conflict of laws principles. The United Nations Convention on Contracts for the International Sale of Goods shall not apply.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">10.5 Venue</h3>
									<p>
										If arbitration is deemed unenforceable, you and DalbumX agree that any judicial proceeding shall be brought exclusively in the state or federal courts located in Miami-Dade County, Florida.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">11. MODIFICATIONS TO THE SERVICE AND TERMS</h2>
									<p>
										DalbumX may modify, suspend, or discontinue the Service or any feature at any time without notice. DalbumX may modify these Terms at any time. Material changes will be communicated via email or by posting a notice on the Service at least 30 days before they take effect. 
										Your continued use after changes become effective constitutes acceptance. If you do not agree, you must discontinue use of the Service.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">12. THIRD-PARTY CONTENT AND LINKS</h2>
									<p>
										The Service may contain links to third-party websites, embedded videos from YouTube or Vimeo, and other third-party content. DalbumX is not responsible for the content, accuracy, or practices of third-party websites or services. Your use of third-party services is governed by their 
										terms and privacy policies.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">13. FUTURE FEATURES AND PAYMENTS</h2>
									<p>
										The Service may include paid features and purchases in the future. Any payments will be processed securely. Refund policies and payment terms for any paid features will be described in the applicable service agreements and at the time of purchase.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">14. PRIVACY AND DATA PROTECTION</h2>
									<p>
										Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your personal information. By using the Service, you consent to the collection and use of your information as described in our Privacy Policy.
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">15. FORCE MAJEURE</h2>
									<p>
										DalbumX shall not be liable for any failure or delay in performance of its obligations due to causes beyond its reasonable control, including acts of God, war, terrorism, natural disasters, pandemics, government actions, or internet outages
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold">16. GENERAL PROVISIONS</h2>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">16.1 Entire Agreement</h3>
									<p>
										These Terms, together with the Artist Agreement, EULA, Content Policy, Copyright/DMCA Policy, and Privacy Policy, constitute the entire agreement between you and DalbumX and supersede all prior agreements.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">16.2 Severability</h3>
									<p>
										If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full effect.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">16.3 No Waiver</h3>
									<p>
										No waiver of any provision shall be deemed or constitute a waiver of any other provision, nor shall any waiver constitute a continuing waiver.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">16.4 Assignment</h3>
									<p>
										You may not assign or transfer these Terms without DalbumX's prior written consent. DalbumX may assign these Terms in connection with a merger, acquisition, or sale of substantially all assets.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">16.5 Electronic Communications</h3>
									<p>
										You consent to receive communications from DalbumX electronically via email or by posting notices on the Service. All electronic communications satisfy any legal requirement that communications be in writing.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">16.6 Relationship of Parties</h3>
									<p>
										The relationship between you and DalbumX is that of independent contractors. Nothing in these Terms creates a partnership, joint venture, agency, or employment relationship.
									</p>

									<h3 className="fw-bold mt-3 mb-2 heading-bold">17. CONTACT INFORMATION</h3>

									<p>For questions about these Terms or the DalbumX Service, please contact:</p>
									<p>
										<strong>DalbumX LLC</strong>
										<br />
										534 3rd Ave., #1204
										<br />
										Brooklyn, NY 11215
										<br />
										Email: legal@dalbumx.com
										<br />
										Copyright Issues: copyright@dalbumx.com
										<br />
										General Support: support@dalbumx.com
										<br />
										Phone: 917-547-9003
									</p>

									<h2 className="fw-bold mt-4 mb-3 heading-bold"><center>ACKNOWLEDGMENT</center></h2>

									<p>
										<center>
											BY ACCESSING OR USING DALBUMX, YOU ACKNOWLEDGE THAT YOU HAVE READ,
											UNDERSTOOD, AND AGREE TO BE BOUND BY THESE GENERAL TERMS AND CONDITIONS
											AND ALL AGREEMENTS REFERENCED HEREIN.
										</center>
									</p>
									
									<h3 className="fw-bold mt-3 mb-2 heading-bold"><center>END OF GENERAL TERMS AND CONDITIONS</center></h3>

									<p><center>Effective Date: June 5, 2026</center></p>
			

								</div>

							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</div>
	);
};

export default TermsAndCondition;